var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-layout"},[_c('video',{staticStyle:{"width":"100%","height":"100%"},attrs:{"controls":"","id":_vm.id}})])}
var staticRenderFns = []

export { render, staticRenderFns }